import React, { useState } from "react";
import "./Agenda.scss"; // Import your CSS
import { useTranslation } from "react-i18next";

const Agenda = () => {
  // State to keep track of the active tab (Day 1, Day 2, Day 3)
  const [activeTab, setActiveTab] = useState(0);

  const { t } = useTranslation();

  const agendaRaw = t("scheduleSection.agenda", { returnObjects: true });
  const agendaData = Array.isArray(agendaRaw) ? agendaRaw : [];

  // Handle tab switching by setting the active tab
  const handleTabClick = (index) => {
    setActiveTab(index); // Set the active tab based on the clicked index
  };

  return (
    <div className="agenda-container">
      {/* Tabs */}
      <div className="tabs">
        {agendaData.map((dayData, index) => (
          <div
            key={index}
            className={`tab ${activeTab === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)} // Handle tab click
          >
            {dayData.day}
          </div>
        ))}
      </div>

      {/* Content for the selected day */}
      <div className="agenda-content">
        {/* <div className="coming-soon-container">
          <h2>{t("scheduleSection.comingSoon")}</h2>
        </div> */}

        {agendaData[activeTab].schedule.map((item, index) => (
          <div
            // className={`agenda-item ${
            //   item.instructor.toLowerCase().includes("seniors") || item.instructor.toLowerCase().includes("seniori")
            //     ? "seniors"
            //     : item.instructor.toLowerCase().includes("kids") || item.instructor.toLowerCase().includes("pioniri")
            //     ? "juniors"
            //     : ""
            // }`}
            className="agenda-item"
            key={index}
          >
            <div className="agenda-time">{item.time}</div>
            <div className="agenda-instructor">{item.instructor}</div>
            <div className="agenda-hall">{item.hall}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Agenda;
